import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import classNames from 'classnames';

// Components
import { actionHandler } from '../../../utilities/form/formUtils';
import Error from '../../Form/Error';
import { getDate } from '../../../utilities/form/formValidators';
import Label from '../../Form/Label';
import { setLocaleToDanish } from '../../../utilities/i18nUtil';

setLocaleToDanish();

const DatePicker = ({
  id,
  label,
  actions,
  dispatch,
  values,
  setValues,
  setFieldValue,
  hidden,
  dateFormat,
  maxDate,
  minDate,
  startDate,
  type,
  columns,
  className,
  autoComplete,
  required,
  errors,
  labelActions,
  readOnly,
}) => {
  if (hidden) {
    return <div/>;
  }

  const touched = { [id]: true };

  const formFieldClass = classNames('form__field--date date-picker', {
    [`form__field--${id}`]: id,
    [`form__field--${type}`]: type,
    [`form__field--${columns}col`]: columns,
    [`form__field--${className}`]: className,
  });

  const valid = (current) => {
    // Implement min and max date;
    if (minDate) {
      const date = getDate(minDate, values, dateFormat);
      return current.isAfter(date) || date.valueOf() === current.valueOf();
    }
    if (maxDate) {
      const date = getDate(maxDate, values, dateFormat);
      return current.isBefore(date) || date.valueOf() === current.valueOf();
    }
    return true;
  };

  const onChangeHandler = (date) => {
    const name = `${[id]}Text`;
    if (typeof date === 'object') {
      setFieldValue(id, date.format(dateFormat));
      setFieldValue(name, date.format('LL'));
    } else {
      setFieldValue(id, date);
      const dateTxt = getDate(date, values, dateFormat);
      if (dateTxt && dateTxt.isValid()) {
        setFieldValue(name, dateTxt.format('LL'));
      }
    }
    if (actions) {
      actionHandler(actions, null, null, dispatch, values, setValues);
    }
  };

  const labelProps = {
    actions: labelActions,
    dispatch,
    values,
    setValues,
  };

  return (
    <div className={formFieldClass}>

      {/* Label */}
      {label &&
      <Label
        className='form__label'
        label={label}
        {...labelProps}
      />
      }

      <Datetime
        id={id}
        dateFormat={dateFormat}
        inputProps={{
          id,
          className: 'form__item',
          placeholder: dateFormat,
          required,
          autoComplete,
          readOnly,
        }}
        timeFormat={false}
        value={values[id] ? values[id] : startDate}
        isValidDate={valid}
        onChange={onChangeHandler}
        closeOnSelect={true}
      />

      {/* Error Message */}
      <Error touched={touched} errors={errors} id={id} />
    </div>
  );
};

export default DatePicker;

DatePicker.defaultProps = {
  dateFormat: 'DD-MM-YYYY',
  minDate: null,
  maxDate: null,
  actions: null,
  columns: '7',
  className: '',
  required: true,
  autoComplete: 'off',
  labelActions: null,
  readOnly: false,
};

DatePicker.propTypes = {
  dispatch: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  actions: PropTypes.array,
  hidden: PropTypes.bool.isRequired,
  columns: PropTypes.string,
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
  startDate: PropTypes.string,
  dateFormat: PropTypes.string,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  autoComplete: PropTypes.string,
  required: PropTypes.bool,
  errors: PropTypes.object.isRequired,
  labelActions: PropTypes.object,
  readOnly: PropTypes.bool,
};
